import { Alert, Snackbar } from '@mui/material'
import { useContext } from 'react'
import { AppContext } from '../../store/AppProvider'
import { HIDE_ALERT } from '../../store/reducer/AlertNotifierReducer'

export const AlertNotifier = () => {
    const { alert: { showAlert, alertMessage, alertType }, setAlert } = useContext(AppContext)
    return (
        <div>
            <Snackbar
                open={showAlert} autoHideDuration={3000} onClose={() => setAlert({ type: HIDE_ALERT })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={() => setAlert({ type: HIDE_ALERT })} variant='filled' severity={alertType} sx={{ width: "100%" }}>
                    {alertMessage || ""}
                </Alert>
            </Snackbar>
        </div>
    )
}
